import { InformationType } from "@/common/models";
import { GqlMockCall } from "@/gql/lib";
import { GqlCallsKey } from "../demo/gql.resolver";

const vars = ["main-1", "main-2", "main-3", "main-4", "level-l", "level-h"];
const MOCK_EVENT_PROFILE_INSIGHT = Array(6)
  .fill({})
  .map((_, index) => ({
    id: index,
    name: "Mock Event Profile Insight " + index + 1,
    color: vars[index],
  }));

// @ts-ignore
export const compliance: Record<Partial<GqlCallsKey>, GqlMockCall> = {
  /*  "compliance.employees-per-events-profile-count-for-label": {
    delay: 1000,
    payload: async () => {
      return MOCK_EVENT_PROFILE_INSIGHT.map((ins) => {
        return {
          ...ins,
          count: 10,
        };
      });
    },
  }, */
  /*   "compliance.employees-count-per-l1": {
    delay: 1000,
    payload: async (l1s: string[]) => {
      const { SharedState } = await import("@/common/state");
      return l1s.map((l1) => {
        return {
          id: l1,
          name: SharedState.allInfoTypes.value[l1].labelName,
          count: 10,
        };
      });
    },
  }, */
  /*  "compliance.events-profile-count-for-label": {
    delay: 1000,
    payload: async () => {
      return MOCK_EVENT_PROFILE_INSIGHT.map((ins) => {
        return {
          ...ins,
          count: 10,
        };
      });
    },
  }, */
  /*   "compliance.events-count-per-l1": {
    delay: 1000,
    payload: async (l1s: string[]) => {
      const { SharedState } = await import("@/common/state");
      return l1s.map((l1) => {
        return {
          id: l1,
          name: SharedState.allInfoTypes.value[l1].labelName,
          count: 10,
        };
      });
    },
  }, */
};
